<app-header (toggleLeftSidenav)="leftMenu = true" (toggleRightSidenav)="rightMenu = true" [userBalance]="userBalance"
  [username]="username"></app-header>

<div class="container-xl min-container-height">
  <div class="space-10"></div>
  <div class="pb-5 row">
    <div class="col-md-3 col-xl-2 order-2 order-md-1 sticky-position" [ngClass]="{ 'd-none d-xl-block': !isHome }"
      #slipContainerLeft>
      <div class="space-10 hide-large"></div>
      <app-calendar></app-calendar>
      <div class="space-10"></div>
      <app-quick-view></app-quick-view>
      <div class="space-30"></div>
    </div>

    <div class="col-12 col-md router-height order-1 order-md-2">
      <!-- <div class="maintenence" *ngIf="!maintanceHide">
        <span>
          {{ 'HOME.MAINTANANCE' | translate }}
        </span>
      </div> -->
      <app-streaming-player></app-streaming-player>

      <app-quarte-races class="d-xl-none d-sm-block"
        *ngIf="isHome && !router.url.includes('races/all') || router.url.includes('next-races/all')"
        [collapsed]="bettingSlipStatus">
      </app-quarte-races>

      <router-outlet></router-outlet>
    </div>

    <div class="col-lg-3 col-xl-2 order-md-3 d-none d-xl-block">
      <div [style.position]="activeBetSlipIndex === 0 ? 'sticky' : 'relative'" class="slip-container">
        <p-accordion [(activeIndex)]="activeBetSlipIndex" [ngClass]="{ 'd-none': !bettingSlipStatus }">
          <p-accordionTab header="{{ 'BETTING_SLIP.YOUR_BETTING_SLIP' | translate }}">
            <div class="card-body p-2" *ngIf="info">
              <div class="d-flex flex-column justify-content-start align-items-stretch">
                <app-your-betting-info [info]="info" [raceDate]="raceDate"
                  (clearAll)="clearAll()"></app-your-betting-info>
                <div class="d-flex flex-column justify-content-start align-items-stretch pt-4">
                  <form class="mb-4" [formGroup]="betService.raceDetailsForm">
                    <label class="mb-0">{{ "RACES.STAKES_IN" | translate }}
                      {{authService.currentCurrency$ |async
                      }}
                    </label>
                    <!-- <input class="stake-in text-center w-100"
                        [class.stake-red]="betService.raceDetailsForm.invalid === true"
                        formControlName="selectedStake"
                        [(ngModel)]="betService.selectedStake"
                        appTwoDigitDecimaNumber /> -->
                    <ng-container *ngIf="authService.currentCountry$ | async as country">
                      <p-dropdown [options]="country.stakes" [(ngModel)]="betService.selectedStake"
                        [ngModelOptions]="{ standalone: true }">
                        <ng-template pTemplate="selectedItem">
                          {{ betService.selectedStake | number: "1.2-2" }}
                        </ng-template>
                        <ng-template let-stakeItem pTemplate="stakeItem">
                          {{ stakeItem | number: "1.2-2" }}
                        </ng-template>
                      </p-dropdown>
                    </ng-container>
                  </form>
                  <!-- Bet Cart Price Info  -->
                  <ng-container *ngIf="betService.allAddedBetsInCart$.value.length > 0">
                    <ng-container *ngFor="let bet of allBetsOnCart$ | async">
                      <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1">
                        <div>
                          <span>{{ bet?.selectedBet?.name | bettingType | translate | capitalizeFirst}} : </span>
                          <span>{{ bet?.numberofBets }}</span>
                        </div>
                        <span>{{ bet?.totalPrice| number: "1.2-2" }}{{" "}}{{authService.currentCurrency$ |async
                          }}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>

                  <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1"
                    *ngIf="this.betService.showCurrentBet$ | async">
                    <div>
                      <span> {{ info?.selectedBet?.name | bettingType | translate| capitalizeFirst }}: </span>
                      <span>{{ betService.numberofBets}}</span>
                    </div>
                    <span>{{ betService.totalPrice | number: "1.2-2" }}{{" "}}{{authService.currentCurrency$ |async
                      }}
                    </span>
                  </div>

                  <div class="d-flex flex-row justify-content-between align-items-center my-1">
                    <div>
                      {{"Total" | translate}}
                    </div>
                    <span>{{ betService.totalAllBetsOnCart + betService.totalPrice | number: "1.2-2"
                      }}{{" "}}{{authService.currentCurrency$ |async
                      }}

                    </span>
                  </div>
                  <!--  Bet Cart Price Info  -->

                  <button *ngIf="!betService.showCurrentBet$.value && betService.allAddedBetsInCart$.value.length > 0"
                    class="btn btn-md btn-success text-center mt-4" (click)="showConfirmBetPopup()" [ngClass]="{
                      'kt-spinner kt-spinner--right kt-spinner--light':
                        betService.placeBetSpinner
                    }">
                    <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
                      style="font-size: 1.5rem"></i>
                    {{ "RACES.PLACE_BET" | translate }}
                  </button>

                  <button *ngIf="betService.showCurrentBet$.value || betService.allAddedBetsInCart$.value.length == 0"
                    [disabled]="
                      (info?.isFormValid === false ||
                      betService.numberofBets <= 0 ||
                      betService.placeBetSpinner
                      )

                    " class="btn btn-md btn-success text-center mt-4" (click)="showConfirmBetPopup()" [ngClass]="{
                      'kt-spinner kt-spinner--right kt-spinner--light':
                        betService.placeBetSpinner
                    }">
                    <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
                      style="font-size: 1.5rem"></i>
                    {{ "RACES.PLACE_BET" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <div class="space-10" *ngIf="bettingSlipStatus"></div>
        <!-- <app-accumulator *ngIf="!router.url.includes('/race/') || !bettingSlipStatus"></app-accumulator> -->
        <!-- <div class="space-10"></div> -->

        <app-top-wining [collapsed]="bettingSlipStatus"></app-top-wining>

        <app-opportunity *ngIf="!isHome && !router.url.includes('next-races/all')" [page]="'home'"
          [collapsed]="bettingSlipStatus" [sideCol]="true">
        </app-opportunity>

        <app-quarte-races *ngIf="!router.url.includes('races/all') || router.url.includes('next-races/all')"
          [collapsed]="bettingSlipStatus">
        </app-quarte-races>

        <!-- <app-starter-search></app-starter-search>
                        <div class="space-10"></div>
                        <app-head2head></app-head2head>
                        <div class="space-10"></div>
                        <app-side-more></app-side-more> -->
      </div>
    </div>
  </div>
</div>
<div class="sticky-footer d-xl-none">
  <app-race-footer [cuponInfo]="info" [bettingSlipStatus]="bettingSlipStatus" [isFormValid]="false"
    [raceDate]="raceDate" [selectedBet]="info?.selectedBet?.name" (clearAll)="clearAll()">
  </app-race-footer>
</div>
<app-footer></app-footer>

<p-sidebar [(visible)]="leftMenu" appendTo="body" [baseZIndex]="10000" styleClass="p-2 left-sidebar "
  [style]="{ width: '17em' }">
  <app-left-sidenav (closeLeftSidenav)="leftMenu = false"></app-left-sidenav>
</p-sidebar>

<p-sidebar [(visible)]="rightMenu" position="right" appendTo="body" [baseZIndex]="10000" styleClass="p-2 right-sidebar "
  [style]="{ width: '19em' }">
  <app-right-sidenav (closeRightSidenav)="rightMenu = false" [userBalance]="userBalance" [username]="username">
  </app-right-sidenav>
</p-sidebar>

<!-- TOOLS -->
<app-language-toolbar class="d-desktop"></app-language-toolbar>
<app-sticky-toolbar></app-sticky-toolbar>